export const getIsCurrentPage = (path, router) => {
  return router.asPath.includes(path);
};
